import { useEffect } from 'react';
import { Box } from '@mui/material';

import { AcceptPaymentMethodEnum } from '../../../enums/AcceptPaymentMethodEnum';
import "./PaymentSetupPage.scss";
import PaymentSetupPageMainContainer from '../../../components/PageComponents/PaymentSetupComponents/PaymentSetupPageMainContainer';
import Footer from '../../../components/CommonComponents/Footer/Footer';

export interface BankAccountDetails {
  accountNumber: string,
  bankIFSC: string,
  holderName: string,
  bankName: string
}

export interface SellerPaymentFormData {
  selectedPaymentMode: AcceptPaymentMethodEnum;
  upiId: string;
  bankAccountDetails: BankAccountDetails;
  acknowledgementChecked: boolean;
}

interface PaymentSetupPageProps {
  setCurrentPage: any;
  savedFormData: SellerPaymentFormData;
  savePaymentFormData: Function;
}

const PaymentSetupPage = ({
  setCurrentPage,
  savedFormData,
  savePaymentFormData
}: PaymentSetupPageProps) => {

  useEffect(() => {
    window.scrollTo(0,0)
  }, [])

  const uponValidatedSubmission = (paymentFormData: SellerPaymentFormData) => {
      savePaymentFormData(paymentFormData)
      setCurrentPage((currentPage: number) => currentPage + 1)
  }

  return (
    <Box className='payment-setup-page'>
      <PaymentSetupPageMainContainer withButtonPanel={true} savedFormData={savedFormData} uponValidatedSubmission={uponValidatedSubmission} onBackPress={() => setCurrentPage((currentPage: number) => currentPage - 1)} />
      <Footer />
    </Box>
  )
}

export default PaymentSetupPage